// extracted by mini-css-extract-plugin
export default {"item":"MenuItem_item__x-sfS","selected":"MenuItem_selected__zLcv6"};